import { Traffic } from '../../types/traffic';

export const SET_TRAFFIC = 'SET_TRAFFIC';

export class SetTraffic {
  readonly type = SET_TRAFFIC;
  readonly payload: Traffic[];

  constructor(types: Traffic[]) {
    this.payload = types;
  }
}

export type Action = SetTraffic;
